module.exports = __webpack_public_path__ + "5d4f1cca7c6883e70d8ce516bd2ad8d3.png";